import React from "react";

const SignIn = () => <div>Sign In</div>;

export default SignIn;